"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMerchantDefaultConfig = getMerchantDefaultConfig;
exports.saveMerchantDefaultConfig = saveMerchantDefaultConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 获取店铺默认配置
function getMerchantDefaultConfig() {
  // return request({
  //   url: '/admin/merchant/store/default/config/get',
  //   method: 'get'
  // })
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchant/store/default/config/get',
    method: 'get'
  });
}

// 保存或更新店铺默认配置
function saveMerchantDefaultConfig(data) {
  return (0, _request.default)({
    url: '/admin/merchant/store/default/config/save',
    method: 'post',
    data: data
  });
}